import {
  PlaycastMessage,
  PlaycastMessageRemoteSendFunctionCommand,
  // PlaycastMessageRemoteChangeCaptureMode,
  // PlaycastMessageRemoteChangeDefaultStream,
  // PlaycastMessageRemoteChangeDisplay,
  // PlaycastMessageRemoteEnableSurfing,
  // PlaycastMessageRemoteKickPlayer,
  // PlaycastMessageRemoteSetAllowedGamepadInput,
  // PlaycastMessageRemoteSetAllowedKeyboardInput,
  // PlaycastMessageRemoteSetAllowedMouseInput,
  // PlaycastMessageRemoteSetAudioEnabled,
  // PlaycastMessageRemoteSetMicrophone,
  // PlaycastMessageRemoteSetMicrophoneEnabled,
  // PlaycastMessageRemoteSetStreamTitle,
  PlaycastMessageTarget,
} from '../types';

const TARGET = 'remote';
type msg = PlaycastMessage<PlaycastMessageTarget>;

export const sendFunctionCommand = (message: msg): PlaycastMessage<PlaycastMessageRemoteSendFunctionCommand> | undefined => {
  const target = message.header.target;
  const action = message.header.action;

  if (target !== TARGET) {
    console.error(`Failed to validate message: target is not ${TARGET}`);
    return undefined;
  }
  if (action !== 'sendFunctionCommand') {
    console.error(`Failed to validate message: action is not sendFunctionCommand`);
    return undefined;
  }

  return message as PlaycastMessage<PlaycastMessageRemoteSendFunctionCommand>;
};

// export const setStreamTitle = (message: msg): PlaycastMessage<PlaycastMessageRemoteSetStreamTitle> | undefined => {
//   const target = message.header.target;
//   const action = message.header.action;
//   const fail = (field: string) => {
//     console.error(`Failed to validate message: ${field} is missing`);
//     return undefined;
//   };

//   if (target !== TARGET) {
//     console.error(`Failed to validate message: target is not ${TARGET}`);
//     return undefined;
//   }
//   if (action !== 'setStreamTitle') {
//     console.error(`Failed to validate message: action is not setStreamTitle`);
//     return undefined;
//   }

//   const messageObj = message as PlaycastMessage<PlaycastMessageRemoteSetStreamTitle>;
//   const bodyData = messageObj.body.message;
//   // Check required fields.
//   if (bodyData.title === undefined) return fail('body.message.title');
//   return messageObj;
// };

// export const changeDefaultStream = (message: msg): PlaycastMessage<PlaycastMessageRemoteChangeDefaultStream> | undefined => {
//   const target = message.header.target;
//   const action = message.header.action;
//   const fail = (field: string) => {
//     console.error(`Failed to validate message: ${field} is missing`);
//     return undefined;
//   };

//   if (target !== TARGET) {
//     console.error(`Failed to validate message: target is not ${TARGET}`);
//     return undefined;
//   }
//   if (action !== 'changeDefaultStream') {
//     console.error(`Failed to validate message: action is not selectCamera`);
//     return undefined;
//   }

//   const messageObj = message as PlaycastMessage<PlaycastMessageRemoteChangeDefaultStream>;
//   const bodyData = messageObj.body.message;
//   // Check required fields.
//   if (bodyData.streamId === undefined) return fail('body.message.streamId');
//   return messageObj;
// };

// export const changeCaptureMode = (message: msg): PlaycastMessage<PlaycastMessageRemoteChangeCaptureMode> | undefined => {
//   const target = message.header.target;
//   const action = message.header.action;
//   const fail = (field: string) => {
//     console.error(`Failed to validate message: ${field} is missing`);
//     return undefined;
//   };

//   if (target !== TARGET) {
//     console.error(`Failed to validate message: target is not ${TARGET}`);
//     return undefined;
//   }
//   if (action !== 'changeCaptureMode') {
//     console.error(`Failed to validate message: action is not changeCaptureMode`);
//     return undefined;
//   }

//   const messageObj = message as PlaycastMessage<PlaycastMessageRemoteChangeCaptureMode>;
//   const bodyData = messageObj.body.message;
//   // Check required fields.
//   if (bodyData.mode === undefined) return fail('body.message.mode');
//   return messageObj;
// };

// export const kickPlayer = (message: msg): PlaycastMessage<PlaycastMessageRemoteKickPlayer> | undefined => {
//   const target = message.header.target;
//   const action = message.header.action;
//   const fail = (field: string) => {
//     console.error(`Failed to validate message: ${field} is missing`);
//     return undefined;
//   };

//   if (target !== TARGET) {
//     console.error(`Failed to validate message: target is not ${TARGET}`);
//     return undefined;
//   }
//   if (action !== 'kickPlayer') {
//     console.error(`Failed to validate message: action is not kickPlayer`);
//     return undefined;
//   }

//   const messageObj = message as PlaycastMessage<PlaycastMessageRemoteKickPlayer>;
//   const bodyData = messageObj.body.message;
//   // Check required fields.
//   if (bodyData.playerId === undefined) return fail('body.message.playerId');
//   return messageObj;
// };

// export const setAllowedGamepadInput = (message: msg): PlaycastMessage<PlaycastMessageRemoteSetAllowedGamepadInput> | undefined => {
//   const target = message.header.target;
//   const action = message.header.action;
//   const fail = (field: string) => {
//     console.error(`Failed to validate message: ${field} is missing`);
//     return undefined;
//   };

//   if (target !== TARGET) {
//     console.error(`Failed to validate message: target is not ${TARGET}`);
//     return undefined;
//   }
//   if (action !== 'setAllowedGamepadInput') {
//     console.error(`Failed to validate message: action is not setAllowedGamepadInput`);
//     return undefined;
//   }

//   const messageObj = message as PlaycastMessage<PlaycastMessageRemoteSetAllowedGamepadInput>;
//   const bodyData = messageObj.body.message;
//   // Check required fields.
//   if (bodyData.allowed === undefined) return fail('body.message.allowed');
//   return messageObj;
// };

// export const setAllowedKeyboardInput = (message: msg): PlaycastMessage<PlaycastMessageRemoteSetAllowedKeyboardInput> | undefined => {
//   const target = message.header.target;
//   const action = message.header.action;
//   const fail = (field: string) => {
//     console.error(`Failed to validate message: ${field} is missing`);
//     return undefined;
//   };

//   if (target !== TARGET) {
//     console.error(`Failed to validate message: target is not ${TARGET}`);
//     return undefined;
//   }
//   if (action !== 'setAllowedKeyboardInput') {
//     console.error(`Failed to validate message: action is not setAllowedKeyboardInput`);
//     return undefined;
//   }

//   const messageObj = message as PlaycastMessage<PlaycastMessageRemoteSetAllowedKeyboardInput>;
//   const bodyData = messageObj.body.message;
//   // Check required fields.
//   if (bodyData.allowed === undefined) return fail('body.message.allowed');
//   return messageObj;
// };

// export const setAllowedMouseInput = (message: msg): PlaycastMessage<PlaycastMessageRemoteSetAllowedMouseInput> | undefined => {
//   const target = message.header.target;
//   const action = message.header.action;
//   const fail = (field: string) => {
//     console.error(`Failed to validate message: ${field} is missing`);
//     return undefined;
//   };

//   if (target !== TARGET) {
//     console.error(`Failed to validate message: target is not ${TARGET}`);
//     return undefined;
//   }
//   if (action !== 'setAllowedMouseInput') {
//     console.error(`Failed to validate message: action is not setAllowedMouseInput`);
//     return undefined;
//   }

//   const messageObj = message as PlaycastMessage<PlaycastMessageRemoteSetAllowedMouseInput>;
//   const bodyData = messageObj.body.message;
//   // Check required fields.
//   if (bodyData.allowed === undefined) return fail('body.message.allowed');
//   return messageObj;
// };

// export const setAudioEnabled = (message: msg): PlaycastMessage<PlaycastMessageRemoteSetAudioEnabled> | undefined => {
//   const target = message.header.target;
//   const action = message.header.action;
//   const fail = (field: string) => {
//     console.error(`Failed to validate message: ${field} is missing`);
//     return undefined;
//   };

//   if (target !== TARGET) {
//     console.error(`Failed to validate message: target is not ${TARGET}`);
//     return undefined;
//   }
//   if (action !== 'setAudioEnabled') {
//     console.error(`Failed to validate message: action is not setAudioEnabled`);
//     return undefined;
//   }

//   const messageObj = message as PlaycastMessage<PlaycastMessageRemoteSetAudioEnabled>;
//   const bodyData = messageObj.body.message;
//   // Check required fields.
//   if (bodyData.enabled === undefined) return fail('body.message.enabled');
//   return messageObj;
// };

// export const setMicrophone = (message: msg): PlaycastMessage<PlaycastMessageRemoteSetMicrophone> | undefined => {
//   const target = message.header.target;
//   const action = message.header.action;
//   const fail = (field: string) => {
//     console.error(`Failed to validate message: ${field} is missing`);
//     return undefined;
//   };

//   if (target !== TARGET) {
//     console.error(`Failed to validate message: target is not ${TARGET}`);
//     return undefined;
//   }
//   if (action !== 'setMicrophone') {
//     console.error(`Failed to validate message: action is not setMicrophone`);
//     return undefined;
//   }

//   const messageObj = message as PlaycastMessage<PlaycastMessageRemoteSetMicrophone>;
//   const bodyData = messageObj.body.message;
//   // Check required fields.
//   if (bodyData.deviceId === undefined) return fail('body.message.deviceId');
//   return messageObj;
// };

// export const setMicrophoneEnabled = (message: msg): PlaycastMessage<PlaycastMessageRemoteSetMicrophoneEnabled> | undefined => {
//   const target = message.header.target;
//   const action = message.header.action;
//   const fail = (field: string) => {
//     console.error(`Failed to validate message: ${field} is missing`);
//     return undefined;
//   };

//   if (target !== TARGET) {
//     console.error(`Failed to validate message: target is not ${TARGET}`);
//     return undefined;
//   }
//   if (action !== 'setMicrophoneEnabled') {
//     console.error(`Failed to validate message: action is not setMicrophoneEnabled`);
//     return undefined;
//   }

//   const messageObj = message as PlaycastMessage<PlaycastMessageRemoteSetMicrophoneEnabled>;
//   const bodyData = messageObj.body.message;
//   // Check required fields.
//   if (bodyData.enabled === undefined) return fail('body.message.enabled');
//   return messageObj;
// };

// export const changeDisplay = (message: msg): PlaycastMessage<PlaycastMessageRemoteChangeDisplay> | undefined => {
//   const target = message.header.target;
//   const action = message.header.action;
//   const fail = (field: string) => {
//     console.error(`Failed to validate message: ${field} is missing`);
//     return undefined;
//   };

//   if (target !== TARGET) {
//     console.error(`Failed to validate message: target is not ${TARGET}`);
//     return undefined;
//   }
//   if (action !== 'changeDisplay') {
//     console.error(`Failed to validate message: action is not changeDisplay`);
//     return undefined;
//   }

//   const messageObj = message as PlaycastMessage<PlaycastMessageRemoteChangeDisplay>;
//   const bodyData = messageObj.body.message;
//   // Check required fields.
//   if (bodyData.displayId === undefined) return fail('body.message.displayId');
//   return messageObj;
// };

// export const enableSurfing = (message: msg): PlaycastMessage<PlaycastMessageRemoteEnableSurfing> | undefined => {
//   const target = message.header.target;
//   const action = message.header.action;

//   if (target !== TARGET) {
//     console.error(`Failed to validate message: target is not ${TARGET}`);
//     return undefined;
//   }
//   if (action !== 'enableSurfing') {
//     console.error(`Failed to validate message: action is not enableSurfing`);
//     return undefined;
//   }

//   return message as PlaycastMessage<PlaycastMessageRemoteEnableSurfing>;
// };
